import { keys, reduce, isNil, isEmpty } from 'lodash';
import { Validations } from '@utils/helpers';
import { IError } from '@utils/useForm';
import { PaymentForm } from '@models/SIO/Payment.model';

export const validate = (values: PaymentForm) => {
  const fields = keys(values);
  const errors: any = reduce(fields, (result, field: string) => {
    return { ...result, [field]: validateField(values, field) };
  }, {});
  return errors;
}

export const validateField = (values: any, name: string) => {
  const value = values[name];
  let error: IError | undefined = { isValid: true };
  switch (name) {
    case 'others':
      if (values['bank'] === '11') {
        if (isNil(value)) {
          error = { isValid: false }
        } else {
          if (isEmpty(value)) {
            error = { isValid: false, message: "Please enter the name of the bank that issued the credit card" }
          }
          if (!Validations.isDutyOfOccupationValid(value)) {
            error = { isValid: false, message: "Please exclude special characters other than hyphen (-) or apostrophe (')" }
          }
        }

      }
      break;
    case 'name':
      if (isNil(value)) {
        error = { isValid: false };
      } else {
        if (isEmpty(value.trim())) {
          error = { isValid: false, message: "Please enter a valid name" };
        }
      }
      break;
    case 'no':
    case 'bank':
      if (isNil(value) || isEmpty(value)) {
        error = { isValid: false };
      }
      break;
    case 'isAuthorised':
      if (isNil(value) || value === false) {
        error = { isValid: false };
      }
      break;
  }
  return error;
}